import { render } from "./TabGroup.vue?vue&type=template&id=685d68c4&scoped=true"
import script from "./TabGroup.vue?vue&type=script&lang=js"
export * from "./TabGroup.vue?vue&type=script&lang=js"

import "./TabGroup.vue?vue&type=style&index=0&id=685d68c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685d68c4"]])

export default __exports__